<div class="pdf_export_block">
    <div class="du-pdf-header">
        <div class="d-flex align-items-center justify-content-between p-2 px-3" style="gap: 10px;">
            <span class="expoPdfname">Export PDF</span>
            <mat-icon style="width: 24px;height: 24px;color: #101d42;" [mat-dialog-close]="true">close</mat-icon>
        </div>
    </div>

    <!-- desktop view -->
    <div class="du-pdf-desktop">
        <div class="row">
            <div class="col-4" style="padding-right: 0;">
                <form (ngSubmit)="submitFormHandler($event)">
                    <div class="du-left-side-config">
                        <div class="d-flex justify-content-between align-items-center mb-2" style="flex-wrap: wrap;">
                            <div class="labelPDF">Grid Layout</div>
                            <div style="margin: 10px 0;">
                                <mat-button-toggle-group class="toggleButton" (change)="toggleOrientation($event)"
                                    name="pageOrientation" aria-label="page_orientation"
                                    [value]="PDF_PAGE_ORITENTATION">
                                    <mat-button-toggle name="orientation" id="landscape"
                                        value="landscape">Landscape</mat-button-toggle>
                                    <mat-button-toggle name="orientation" id="portrait"
                                        value="portrait">Portrait</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-2" style="flex-wrap: wrap;">
                            <div style="white-space: nowrap;">
                                <input class="form-check-input" type="checkbox" id="exportWithFormatting"
                                    [checked]="PDF_HEADER_NAME" (change)="PDF_HEADER_NAME = Checked($event)" />
                                <label class="labelPDF ml-1" for="exportWithFormatting">
                                    Brand Name
                                </label>
                            </div>
                            <div style="white-space: nowrap;">
                                <input class="form-check-input" type="checkbox" id="exportWithFormatting"
                                    [checked]="PDF_HEADER_LOGO" (change)="PDF_HEADER_LOGO = Checked($event)" />
                                <label class="labelPDF ml-1" for="exportWithFormatting">
                                    Header Logo
                                </label>
                            </div>
                            <div style="white-space: nowrap;">
                                <input class="form-check-input" type="checkbox" id="exportColumnsAsLink"
                                    [checked]="PDF_FOOTER" (change)="PDF_FOOTER = Checked($event)" />
                                <label class="labelPDF ml-1" for="exportColumnsAsLink">
                                    Footer (page count)
                                </label>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-2" style="flex-wrap: wrap;">
                            <div class="labelPDF">Title</div>
                            <div style="position: relative;" #editContainer>
                                <input type="text"   class="form-control" id="pdfHeading" name="pdfheading"
                                    style="width: 250px;border: 1px solid #E8EAEE;border-radius: 8px;height: 30px;font-size: 12px;font-family: 'Poppins';"
                                    [value]="PDF_HEADING" [disabled]="editName" [(ngModel)]="PDF_HEADING"
                                    (change)="PDF_HEADING = (Value($event))" />
                                <i class="fa fa-edit" (click)="editPdfTitle()"
                                    style="font-size: 18px;position: absolute;right: 8px;top:8px;color: red;"></i>
                            </div>
                        </div>
    
                        <div class="d-flex justify-content-between align-items-center mb-2" style="flex-wrap: wrap;">
                            <div class="labelPDF">Title Position</div>
                            <div class="d-flex justify-content-between align-items-center" style="gap: 10px;">
                                <div>
                                    <input class="form-check-input" type="radio" name="alignment" id="left" value="left"
                                        [checked]="PDF_HEADING_ALIGNMENT === 'left'"
                                        (change)="PDF_HEADING_ALIGNMENT = AlignmentValue($event)" />
                                    <label class="form-check-label" for="Left">
                                        Left
                                    </label>
                                </div>
                                <div>
                                    <input class="form-check-input" type="radio" name="alignment" id="center"
                                        value="center" [checked]="PDF_HEADING_ALIGNMENT === 'center'"
                                        (change)="PDF_HEADING_ALIGNMENT = AlignmentValue($event)" />
                                    <label class="form-check-label" for="center">
                                        Center
                                    </label>
                                </div>
                                <div>
                                    <input class="form-check-input" type="radio" name="alignment" id="right"
                                        value="right" [checked]="PDF_HEADING_ALIGNMENT === 'right'"
                                        (change)="PDF_HEADING_ALIGNMENT = AlignmentValue($event)" />
                                    <label class="form-check-label" for="right" style="margin-right: 0 !important;">
                                        Right
                                    </label>
                                </div>
                            </div>
                        </div>
    
                        <div class="d-flex justify-content-between align-items-center mb-2" style="flex-wrap: wrap;">
                            <div class="labelPDF">Title Color</div>
                            <div>
                                <color-picker id="headingColor" [(ngModel)]="PDF_HEADINGCOLOR"
                                    (ngModelChange)="onPDFColorChange($event)" name="pdf-color"></color-picker>
                            </div>
                        </div>
                        
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <div class="labelPDF">Cell Font Size</div>
                            <div >
                                <input type="number" 
                                matTooltip="Click Arrow to change the value" 
                                matTooltipPosition="above"
                                class="form-control" 
                                style="width: 60px; border: 1px solid #E8EAEE; border-radius: 8px; height: 30px;font-size: 12px;" 
                                [(ngModel)]="PDF_CELL_FONTSIZE" 
                                [value]="PDF_CELL_FONTSIZE"
                                (change)="fontSizeChange($event.target)"
                                />
                            </div>
                        </div>

                        <div class="row mb-2 popup_tree">
                            <div class="col-12 labelPDF">
                                Columns
                            </div>
                            <div class="row mt-2">
                                <div class="col-12 d-flex">
                                    <div class="col-6 ">
                                        <input class="form-check-input" type="radio" name="alignmentdata" id="Detail" value="Detail"
                                            [checked]="DETAIL_DATA=='Detail'"  (click)="dataChange('Detail')" (change)="DETAIL_DATA =  AlignmentValue($event)" />
                                        <label class="labelPDF ml-1" for="Detail">
                                            Detail 
                                        </label>
                                    </div>
                                    <div class="col-6 " *ngIf="groupData?.length>0 && columnDefs2.length==0">
                                        <input class="form-check-input" type="radio" name="alignmentdata" id="SUMMARY" value="SUMMARY"
                                            [checked]="DETAIL_DATA=='SUMMARY'" (click)="dataChange('SUMMARY')" (change)="DETAIL_DATA =  AlignmentValue($event)" />
                                        <label class="labelPDF ml-1" for="Detail">
                                            Summary
                                        </label>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="col-12 mt-1">
                                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                                        <button style="margin-bottom: 8px;" mat-icon-button disabled></button>
                                        <mat-checkbox class="checklist-leaf-node"
                                            [checked]="checklistSelection.isSelected(node)"
                                            (change)="todoLeafItemSelectionToggle(node)"
                                            color="primary" >{{node.item}}</mat-checkbox>
                                    </mat-tree-node>

                                    <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent">
                                        <button style="margin-left: 0px !important;" mat-icon-button disabled></button>
                                    </mat-tree-node>

                                    <mat-tree-node *matTreeNodeDef="let node; when: hasChild">
                                        <button style="margin-bottom: 8px;" mat-icon-button matTreeNodeToggle
                                            [attr.aria-label]="'Toggle ' + node.item">
                                            <mat-icon class="mat-icon-rtl-mirror">
                                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                            </mat-icon>
                                        </button>
                                        <mat-checkbox [checked]="descendantsAllSelected(node)"
                                            [indeterminate]="descendantsPartiallySelected(node)"
                                            (change)="todoItemSelectionToggle(node)"
                                            color="primary" style="color: '#101D42';font-weight: 600;">{{node.item}}</mat-checkbox>
                                    </mat-tree-node>
                                </mat-tree>

                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px 0;">
                        <div class="col-12 d-flex justify-content-around align-items-center">
                            <button [disabled]="this.checklistSelection.selected.length == 0" type="submit"
                                (click)="getPreview()" class="btn btn-success" style="font-size: 13px;font-family: Poppins;">
                                Preview
                            </button>
                            <button [disabled]="this.checklistSelection.selected.length == 0" type="submit"
                                (click)="exportPDf()" class="btn btn-primary" style="font-size: 13px;font-family: Poppins;">
                                Export
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-8" style="padding-left: 0;">
                <div class="du-left-side-config" [class.du-preview-center-alignment]="!pdfPreviewData || checklistSelection.selected.length == 0" style="background-color: #F4F5F9;overflow: hidden;height: calc(100dvh - 120px) !important;">
                    <span *ngIf="pdfPreviewData && checklistSelection.selected.length > 0">
                        <iframe [src]="pdfPreviewData" width="100%" height="100%"></iframe>
                    </span>
                    <div *ngIf="!pdfPreviewData || checklistSelection.selected.length == 0">
                        Preview PDF here
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Tablet and Mobile view -->
    <div class="du-pdf-talet">
        <mat-tab-group 
           [@.disabled]="true"
           [disableRipple]="true"
           fitInkBarToContent
           fitInkBarToContent>
           
           <mat-tab>
           
               <ng-template mat-tab-label>
                   <span>{{ 'Config' }}</span>
               </ng-template>
   
                <form (ngSubmit)="submitFormHandler($event)">
                    <div class="du-left-side-config" style="margin: 0 5px;">
                        <div class="d-flex justify-content-between align-items-center mb-2" style="flex-wrap: wrap;">
                            <div class="labelPDF">Grid Layout</div>
                            <div style="margin: 10px 0;">
                                <mat-button-toggle-group class="toggleButton" (change)="toggleOrientation($event)"
                                    name="pageOrientation" aria-label="page_orientation"
                                    [value]="PDF_PAGE_ORITENTATION">
                                    <mat-button-toggle name="orientation" id="landscape"
                                        value="landscape">Landscape</mat-button-toggle>
                                    <mat-button-toggle name="orientation" id="portrait"
                                        value="portrait">Portrait</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-2" style="flex-wrap: wrap;">
                            <div style="white-space: nowrap;">
                                <input class="form-check-input" type="checkbox" id="exportWithFormatting"
                                    [checked]="PDF_HEADER_NAME" (change)="PDF_HEADER_NAME = Checked($event)" />
                                <label class="labelPDF ml-1" for="exportWithFormatting">
                                    Brand Name
                                </label>
                            </div>
                            <div style="white-space: nowrap;">
                                <input class="form-check-input" type="checkbox" id="exportWithFormatting"
                                    [checked]="PDF_HEADER_LOGO" (change)="PDF_HEADER_LOGO = Checked($event)" />
                                <label class="labelPDF ml-1" for="exportWithFormatting">
                                    Header Logo
                                </label>
                            </div>
                            <div style="white-space: nowrap;">
                                <input class="form-check-input" type="checkbox" id="exportColumnsAsLink"
                                    [checked]="PDF_FOOTER" (change)="PDF_FOOTER = Checked($event)" />
                                <label class="labelPDF ml-1" for="exportColumnsAsLink">
                                    Footer (page count)
                                </label>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-2" style="flex-wrap: wrap;">
                            <div class="labelPDF">Title</div>
                            <div style="position: relative;">
                                <input type="text"   class="form-control" id="pdfHeading" name="pdfheading"
                                    style="width: 250px;border: 1px solid #E8EAEE;border-radius: 8px;height: 30px;font-size: 12px;font-family: 'Poppins';"
                                    [value]="PDF_HEADING" [disabled]="editName" [(ngModel)]="PDF_HEADING"
                                    (change)="PDF_HEADING = (Value($event))" />
                                <i class="fa fa-edit" (click)="editPdfTitle()"
                                    style="font-size: 18px;position: absolute;right: 8px;top:8px;color: red;"></i>
                            </div>
                        </div>
    
                        <div class="d-flex justify-content-between align-items-center mb-2" style="flex-wrap: wrap;">
                            <div class="labelPDF">Title Position</div>
                            <div class="d-flex justify-content-between align-items-center" style="gap: 10px;">
                                <div>
                                    <input class="form-check-input" type="radio" name="alignment" id="left" value="left"
                                        [checked]="PDF_HEADING_ALIGNMENT === 'left'"
                                        (change)="PDF_HEADING_ALIGNMENT = AlignmentValue($event)" />
                                    <label class="form-check-label" for="Left">
                                        Left
                                    </label>
                                </div>
                                <div>
                                    <input class="form-check-input" type="radio" name="alignment" id="center"
                                        value="center" [checked]="PDF_HEADING_ALIGNMENT === 'center'"
                                        (change)="PDF_HEADING_ALIGNMENT = AlignmentValue($event)" />
                                    <label class="form-check-label" for="center">
                                        Center
                                    </label>
                                </div>
                                <div>
                                    <input class="form-check-input" type="radio" name="alignment" id="right"
                                        value="right" [checked]="PDF_HEADING_ALIGNMENT === 'right'"
                                        (change)="PDF_HEADING_ALIGNMENT = AlignmentValue($event)" />
                                    <label class="form-check-label" for="right" style="margin-right: 0 !important;">
                                        Right
                                    </label>
                                </div>
                            </div>
                        </div>
    
                        <div class="d-flex justify-content-between align-items-center mb-2" style="flex-wrap: wrap;">
                            <div class="labelPDF">Title Color</div>
                            <div>
                                <color-picker id="headingColor" [(ngModel)]="PDF_HEADINGCOLOR"
                                    (ngModelChange)="onPDFColorChange($event)" name="pdf-color"></color-picker>
                            </div>
                        </div>
                        
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <div class="labelPDF">Cell Font Size</div>
                            <div >
                                <input type="number" 
                                matTooltip="Click Arrow to change the value" 
                                matTooltipPosition="above"
                                class="form-control" 
                                style="width: 60px; border: 1px solid #E8EAEE; border-radius: 8px; height: 30px;font-size: 12px;" 
                                [(ngModel)]="PDF_CELL_FONTSIZE" 
                                [value]="PDF_CELL_FONTSIZE"
                                (change)="fontSizeChange($event.target)"
                                />
                            </div>
                        </div>

                        <div class="row mb-2 popup_tree">
                            <div class="col-12 labelPDF">
                                Columns
                            </div>
                            <div class="row mt-2">
                                <div class="col-12 d-flex">
                                    <div class="col-6 ">
                                        <input class="form-check-input" type="radio" name="alignmentdata" id="Detail" value="Detail"
                                            [checked]="DETAIL_DATA=='Detail'"  (click)="dataChange('Detail')" (change)="DETAIL_DATA =  AlignmentValue($event)" />
                                        <label class="labelPDF ml-1" for="Detail">
                                            Detail 
                                        </label>
                                    </div>
                                    <div class="col-6 " *ngIf="groupData?.length>0 && columnDefs2.length==0">
                                        <input class="form-check-input" type="radio" name="alignmentdata" id="SUMMARY" value="SUMMARY"
                                            [checked]="DETAIL_DATA=='SUMMARY'" (click)="dataChange('SUMMARY')" (change)="DETAIL_DATA =  AlignmentValue($event)" />
                                        <label class="labelPDF ml-1" for="Detail">
                                            Summary
                                        </label>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="col-12 mt-1">
                                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                                        <button style="margin-bottom: 8px;" mat-icon-button disabled></button>
                                        <mat-checkbox class="checklist-leaf-node"
                                            [checked]="checklistSelection.isSelected(node)"
                                            (change)="todoLeafItemSelectionToggle(node)"
                                            color="primary" >{{node.item}}</mat-checkbox>
                                    </mat-tree-node>

                                    <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent">
                                        <button style="margin-left: 0px !important;" mat-icon-button disabled></button>
                                    </mat-tree-node>

                                    <mat-tree-node *matTreeNodeDef="let node; when: hasChild">
                                        <button style="margin-bottom: 8px;" mat-icon-button matTreeNodeToggle
                                            [attr.aria-label]="'Toggle ' + node.item">
                                            <mat-icon class="mat-icon-rtl-mirror">
                                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                            </mat-icon>
                                        </button>
                                        <mat-checkbox [checked]="descendantsAllSelected(node)"
                                            [indeterminate]="descendantsPartiallySelected(node)"
                                            (change)="todoItemSelectionToggle(node)"
                                            color="primary" style="color: '#101D42';font-weight: 600;">{{node.item}}</mat-checkbox>
                                    </mat-tree-node>
                                </mat-tree>

                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding: 15px 0;">
                        <div class="col-12 d-flex justify-content-around align-items-center">
                            <button [disabled]="this.checklistSelection.selected.length == 0" type="submit"
                                (click)="getPreview()" class="btn btn-success" style="font-size: 13px;font-family: Poppins;">
                                Preview
                            </button>
                            <button [disabled]="this.checklistSelection.selected.length == 0" type="submit"
                                (click)="exportPDf()" class="btn btn-primary" style="font-size: 13px;font-family: Poppins;">
                                Export
                            </button>
                        </div>
                    </div>
                </form>
   
           </mat-tab>
           
           <mat-tab>
           
               <ng-template mat-tab-label>
                   <span>{{ 'Preview' }}</span>
               </ng-template>
   
               <div class="du-left-side-config" [class.du-preview-center-alignment]="!pdfPreviewData || checklistSelection.selected.length == 0" style="background-color: #F4F5F9;overflow: hidden;height: calc(100dvh - 120px) !important;">
                    <span *ngIf="pdfPreviewData && checklistSelection.selected.length > 0" >
                        <iframe [src]="pdfPreviewData" width="100%" height="100%"></iframe>
                    </span>
                    <span *ngIf="!pdfPreviewData || checklistSelection.selected.length == 0">
                        Preview PDF here
                    </span>
                </div>
           </mat-tab>
       </mat-tab-group>
    </div>

</div>